import React, { FC } from 'react'
import { PLANN3R_COLOR } from '../../../../constants'
import { Duration } from '../../../../types/plann3r'

import { IProps } from './types'

import './styles.scss'

const DurationField: FC<IProps> = ({
  label, field, colors, value, required, onDurationChange,
}) => {
  return (
    <div key={field.id} className="durations page_field">
      <label
        style={{
          color: colors?.primary ?? PLANN3R_COLOR,
        }}
      >
        {label}
        {required && <sup>*</sup>}
      </label>
      <div>
        {field.durations?.map((duration: Duration, index: number) => {
          return (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                margin: '10px 0px',
                cursor: 'pointer',
              }}
              key={index}
              onClick={() => {
                if(onDurationChange) onDurationChange(duration.label, duration.duration)
              }}
              role="presentation"
            >
              <div
                className={
                  duration.label === value
                    ? 'radio selected'
                    : 'radio'
                }
                style={{
                  marginRight: '10px',
                  borderColor:
                    duration.label === value &&
                    colors?.secondary
                      ? colors.secondary
                      : PLANN3R_COLOR,
                }}
              >
                <div
                  className="inner_radio"
                  style={{
                    backgroundColor: colors?.secondary
                      ? colors.secondary
                      : PLANN3R_COLOR,
                  }}
                />
              </div>
              <span
                style={{
                  color:
                    duration.label === value &&
                    colors?.secondary
                      ? colors.secondary
                      : PLANN3R_COLOR,
                  fontWeight:
                    duration.label === value
                      ? 'bolder'
                      : 'normal',
                }}
              >
                {duration.label + ' - (' + duration.duration + ' min)'}
              </span>
            </div>
          )
        }, this)}
      </div>
    </div>
  )
}

export default DurationField
